import { render } from "./index.vue?vue&type=template&id=ed53ce9a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ed53ce9a&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=ed53ce9a&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed53ce9a"]])

export default __exports__